import React, { useEffect, useState } from "react";
import styles from "../index.module.css"
import SolicitationService from "../../../../services/SolicitationService/SolicitationService"
import LcAccordion from "../../../../components/Generic/LcAccordion";
import LcLoading from "../../../../components/Generic/LcLoading";
import { SolicitationView } from "../../../../models/SolicitationView";
import HeyHoUserService from "../../../../services/HeyHoUserService/HeyHoUserService";
import LcIconLink from "../../../../components/Generic/LcIconLink";
import { PPDropDown } from "processor-plataform-ui";
import { RootState } from "../../../../store/index";
import { UserState } from "../../../../store/reducers/userReducer";
import { useSelector } from "react-redux";

interface Props {
    solicitation: SolicitationView,
    onSubmit: Function
    activeTab: number
}

const SolicitationRequester: React.FC<Props> = (props) => {
    const solicitationService = new SolicitationService(props);
    const heyHoUserService = new HeyHoUserService(props);
    const user = useSelector<RootState, UserState>(state => state.user);

    const [requester, setRequester] = useState<any[any]>([]);
    const [allRequesters, setAllRequesters] = useState<any[any]>([]);
    const [requestersOptions, setRequestersOptions] = useState<any[]>([]);
    const [requestersOption, setRequestersOption] = useState<any>({ label: "", value: `${Number(props.solicitation.idUserRequester)}` });
    const [sendMail, setSendMail] = useState<string>("");
    const [editRequester, setEditRequester] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [dataToSendDefault, setDataToSendDefault] = useState<any>();

    useEffect(() => {
        if (user.id) {
            setDataToSendDefault({
                id: props.solicitation.id,
                idBusinessArea: props.solicitation.idBusinessArea,
                idServiceGroup: props.solicitation.idServiceGroup || 0,
                idService: props.solicitation.idService,
                idProcess: props.solicitation.idProcess,
                idContract: props.solicitation.idContract || 0,
                idClassification: props.solicitation.idClassification || 0,
                idClassificationGroup: props.solicitation.idClassificationGroup || 0,
                idResponsibleUser: Number(props.solicitation.idResponsibleUser),
                urgency: props.solicitation.urgency,
                idOpenMode: props.solicitation.idOpenMode || 0,
                idUserRequester: Number(props.solicitation.idUserRequester),
                idUserUpdate: Number(user.id)
            });
        }
    }, [user])

    const capitalize = str => {
        let isEmail = str.indexOf("@");

        if (isEmail > 0) {
            let newString = str.substring(0, isEmail);
            return newString.charAt(0).toUpperCase() + newString.substr(1);
        }

        return str.charAt(0).toUpperCase() + str.substr(1);
    }

    useEffect(() => {
        if (props.solicitation) {
            GetRequesters();
        }
    }, [props.solicitation]);

    const GetRequesters = async () => {
        try {
            const response = await heyHoUserService.GetRequesters(props.solicitation.idUserRequester, props.solicitation.idCustomer);

            let option = response.data
                .map(i => {
                    return {
                        label: i.nome,
                        value: i.idUser,
                        nick: i.apelido
                    }
                })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 });

            setRequestersOptions(option);
            setAllRequesters(response.data);
            let requester = response.data.find((item) => item.idUser === props.solicitation.idUserRequester);
            requester.nome = (capitalize(requester.nome));
            setRequester(requester);
        }
        catch (error) {
            console.warn(error)
        }
    }

    useEffect(() => {
        requester && requester.email && setSendMail("mailto:" + requester.email);
    }, [requester])

    const handleChangeRequester = (e) => {
        const { name, value } = e.target;
        setRequestersOption({ label: name, value })
    }

    const handleSwitch = async () => {
        setLoading(true);

        let newRequester = allRequesters.find(req => req.idUser === requestersOption.value);
        newRequester.nome = (capitalize(newRequester.nome));
        setRequester(newRequester);

        let dataToSend = {
            ...dataToSendDefault,
            idUserRequester: newRequester.idUser,
        }

        try {
            await solicitationService.postSolicitationUpdate(dataToSend);

        }
        catch (erro) {
            console.warn(erro);
        }

        setLoading(false);
        setEditRequester(false);
        props.onSubmit();
    }

    useEffect(() => {
        if (editRequester) {
            setRequester(allRequesters.find((req: any) => req.idUser === props.solicitation.idUserRequester));
        }
    }, [editRequester])

    const handleFilterRequester = (e: any) => {
        let filteredList = allRequesters.filter(req => {
            return req.nome.toLowerCase().indexOf(e) >= 0 || req.apelido.toLowerCase().indexOf(e) >= 0
        });

        setRequestersOptions((filteredList.length === 0)
            ? requestersOptions
            : filteredList.map(element => {
                return {
                    label: element.nome,
                    value: element.idUser,
                }
            }))
    }

    return (
        <LcLoading loading={loading}>
            <LcAccordion title={"Solicitante"} visible={true} iconNormal>
                {
                    requester && requester.nome &&
                    <div className={styles.requester}>
                        {
                            (editRequester && props.activeTab === 0)
                                ? <div className={styles.editRequester}>
                                    <PPDropDown
                                        openTrigger={"click"}
                                        name={"requester"}
                                        title={"Selecione um Solicitante"}
                                        options={requestersOptions}
                                        onChange={handleChangeRequester}
                                        value={(requestersOptions.length && requestersOption.value) ? parseInt(requestersOption.value) : ""}
                                        placeholderSearch={"Buscar solicitante"}
                                        onFilter={(e) => handleFilterRequester(e.toLowerCase())}
                                    />
                                    <button className={"lc-button bg-info"} onClick={() => handleSwitch()} >Alterar</button>
                                </div>
                                : <div className={styles.requesterInfo}>
                                    <p><strong>{(props.solicitation.nameUserRequester) ? props.solicitation.nameUserRequester : requester.nome}</strong></p>
                                    <p>{props.solicitation.nameCustomer}</p>
                                    {
                                        requester.email && !props.solicitation.nameUserRequester.includes("@") &&
                                        <a href={sendMail} >{requester.email} {requester.otherEmails ? `/${requester.otherEmails}` : ""}</a>
                                    }
                                    {
                                        requester.telefone &&
                                        <p>
                                            <i className={"ppi ppi-phone"} /> / {requester.telefone}
                                        </p>
                                    }
                                    {
                                        requester.departamento &&
                                        <p>{requester.departamento}</p>
                                    }
                                </div>
                        }
                        {
                            props.solicitation.idStatus !== 6 && props.solicitation.idStatus !== 8 &&
                            <LcIconLink icon={"ppi ppi-pencil"} tooltip={"Editar"} onClick={() => setEditRequester(!editRequester)} />
                        }
                    </div>
                }
            </LcAccordion>
        </LcLoading>
    );
};

export default SolicitationRequester;